export type Permission =
  | 'APP_hrt_insightpartner-bluredcare_admin'
  | 'GEA_App_Administrator'
  | 'GEA_App_Operator'
  | 'gea_read_only'
  | 'customer'
  | 'customerAdmin'
  | 'admin'
  | 'maintenance_manager'
  | 'technician'
  | 'executive_board';
export interface PermissionStateModel {
  permission: Permission;
}

export const ADMIN_ROLES: Permission[] = ['APP_hrt_insightpartner-bluredcare_admin', 'GEA_App_Administrator'];
export const NON_ADMIN_ROLES: Permission[] = [
  'GEA_App_Operator',
  'admin',
  'customer',
  'customerAdmin',
  'executive_board',
  'gea_read_only',
  'maintenance_manager',
  'technician',
];
